import BarMark from "@/components/landing/BarMark";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-stone-200 bg-[#f3efe6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div className="flex items-center gap-3">
          <span className="ranq-wordmark text-[28px] text-stone-900">ranq</span>
          <BarMark size={20} variant="solid" className="text-stone-900 -ml-0.5" />
          <span className="hidden sm:inline-block ml-3 pl-3 border-l border-stone-300/80 text-[10px] uppercase tracking-[0.22em] text-stone-600 font-medium leading-tight">
            Legal
            <br />
            Intelligence
          </span>
        </div>

        <p
          data-testid="footer-tagline"
          className="text-sm text-stone-700 max-w-md md:text-right"
        >
          Ranq — AI-powered submissions for legal directories.
        </p>

        <div className="text-sm text-stone-500">
          © {new Date().getFullYear()} Ranq.
        </div>
      </div>
    </footer>
  );
}
